module.exports = __webpack_public_path__ + "static/media/mashkanta.e3cda86e.svg";